/**
 * @file The one in-memory proxy holding every analytics answer, keyed by
 * `analyticsAnswerKey`. Written only by `useAnalyticsAnswer`; read through
 * `useSnapshot` one key at a time, so a component re-renders only for the
 * answers it reads. A settled answer replaces its whole entry, unless it
 * equals the one already there or is a failure over an answered entry; a
 * refetch never writes loading over an answer. Nothing here is persisted.
 */
import { proxy } from 'valtio';

import type { AnalyticsAnswer } from './index.types';

export const analyticsAnswers = proxy<Record<string, AnalyticsAnswer>>({});
